import React from 'react';

import { Stack, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { Calendar1, Calendar2, IconProps } from 'iconsax-reactjs';
import { useTranslation } from 'react-i18next';

import { IUser } from '../../../../../../types/user.type';
import { DateLabelStyled, DateStyled } from '../../styles';

const DATE_FORMAT = 'DD MMMM YYYY';

interface IProps {
  user: IUser;
}

const UserInfoDates = React.memo(({ user }: IProps) => {
  const { t, i18n } = useTranslation();

  const theme = useTheme();

  const iconProps: IconProps = {
    size: 24,
    color: theme.palette.secondary[800],
  };

  const dateFormatted = React.useCallback(
    (date: string) => dayjs(date).locale(i18n.language).format(DATE_FORMAT),
    [i18n.language],
  );

  return (
    <Stack spacing={1.5}>
      {user.birthday && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Calendar2 {...iconProps} />

          <Stack spacing={0.5}>
            <DateLabelStyled variant="xxs">{t('general.birthday')}</DateLabelStyled>
            <DateStyled variant="sm">{dateFormatted(user.birthday)}</DateStyled>
          </Stack>
        </Stack>
      )}

      {user.date_available && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Calendar1 {...iconProps} />

          <Stack spacing={0.5}>
            <DateLabelStyled variant="xxs">{t('general.available_after')}</DateLabelStyled>
            <DateStyled variant="sm">{dateFormatted(user.date_available)}</DateStyled>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
});

export default UserInfoDates;
